import produce, { castDraft, } from 'immer';
import { OrganizationActionType, } from './actions';
const orgsByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case OrganizationActionType.SET_ORGANIZATION:
            return produce(currentState, (draft) => {
                const actualAction = action;
                // add/replace new org to the currentState
                draft[actualAction.organization.id] = castDraft(actualAction.organization);
            });
        case OrganizationActionType.CLEAR_ORGANIZATION:
            return produce(currentState, () => {
                // reset the "orgsById" to {}
                return {};
            });
        default:
            return currentState;
    }
};
const orgIdsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case OrganizationActionType.SET_ORGANIZATION:
            return produce(currentState, (draft) => {
                const actualAction = action;
                draft.push(actualAction.organization.id);
            });
        case OrganizationActionType.CLEAR_ORGANIZATION:
            return produce(currentState, () => {
                // reset the "orgsIds" to []
                return [];
            });
        default:
            return currentState;
    }
};
const orgsByBaseUrlReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case OrganizationActionType.SET_ORGANIZATION:
            return produce(currentState, (draft) => {
                var _a;
                const actualAction = action;
                // add/replace new org to the currentState
                if ((_a = actualAction.organization.opsConsoleSettings) === null || _a === void 0 ? void 0 : _a.baseUrl) {
                    draft[actualAction.organization.opsConsoleSettings.baseUrl] = castDraft(actualAction.organization);
                }
            });
        case OrganizationActionType.CLEAR_ORGANIZATION:
            return produce(currentState, () => {
                // reset the "orgsByBaseUrl" to {}
                return {};
            });
        default:
            return currentState;
    }
};
const baseUrlsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case OrganizationActionType.SET_ORGANIZATION:
            return produce(currentState, (draft) => {
                var _a;
                const actualAction = action;
                // Add the opsConsoleSettings.baseUrl to the list of baseUrls if this organization has a opsConsoleSettings.baseUrl
                if ((_a = actualAction.organization.opsConsoleSettings) === null || _a === void 0 ? void 0 : _a.baseUrl) {
                    draft.push(actualAction.organization.opsConsoleSettings.baseUrl);
                }
            });
        case OrganizationActionType.CLEAR_ORGANIZATION:
            return produce(currentState, () => {
                // reset the "baseUrls" to []
                return [];
            });
        default:
            return currentState;
    }
};
export const organizationsStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.orgsById = castDraft(orgsByIdReducer(currentState.orgsById, action));
        draft.orgIds = castDraft(orgIdsReducer(currentState.orgIds, action));
        draft.orgsByBaseUrl = castDraft(orgsByBaseUrlReducer(currentState.orgsByBaseUrl, action));
        draft.baseUrls = castDraft(baseUrlsReducer(currentState.baseUrls, action));
    });
};
